// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file profile.proto (package domain, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { ProfileAuthenticatorLock, ProfileProfileLock, VaultLockCreationData } from "./locks_pb";
import { file_locks } from "./locks_pb";
import type { ProfileType } from "./profile_type_pb";
import { file_profile_type } from "./profile_type_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file profile.proto.
 */
export const file_profile: GenFile = /*@__PURE__*/
  fileDesc("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", [file_locks, file_profile_type]);

/**
 * @generated from message domain.ProfileData
 */
export type ProfileData = Message<"domain.ProfileData"> & {
  /**
   * null uuids for creation
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: domain.ProfileType profile_type = 15;
   */
  profileType: ProfileType;

  /**
   * @generated from field: string key_generation_id = 2;
   */
  keyGenerationId: string;

  /**
   * @generated from field: bytes high_security_identity_sig_pub_key = 3;
   */
  highSecurityIdentitySigPubKey: Uint8Array;

  /**
   * @generated from field: bytes high_security_vault_key_enc_pub_key = 4;
   */
  highSecurityVaultKeyEncPubKey: Uint8Array;

  /**
   * @generated from field: bytes high_security_vault_key_enc_pub_key_signature = 5;
   */
  highSecurityVaultKeyEncPubKeySignature: Uint8Array;

  /**
   * @generated from field: bytes high_security_profile_seed_enc_pub_key = 6;
   */
  highSecurityProfileSeedEncPubKey: Uint8Array;

  /**
   * @generated from field: bytes high_security_profile_seed_enc_pub_key_signature = 7;
   */
  highSecurityProfileSeedEncPubKeySignature: Uint8Array;

  /**
   * @generated from field: bytes storable_sig_pub_key = 8;
   */
  storableSigPubKey: Uint8Array;

  /**
   * @generated from field: bytes storable_sig_pub_key_signature = 9;
   */
  storableSigPubKeySignature: Uint8Array;

  /**
   * @generated from field: bytes storable_vault_key_enc_pub_key = 10;
   */
  storableVaultKeyEncPubKey: Uint8Array;

  /**
   * @generated from field: bytes storable_vault_key_enc_pub_key_signature = 11;
   */
  storableVaultKeyEncPubKeySignature: Uint8Array;

  /**
   * @generated from field: bytes storable_profile_seed_enc_pub_key = 12;
   */
  storableProfileSeedEncPubKey: Uint8Array;

  /**
   * @generated from field: bytes storable_profile_seed_enc_pub_key_signature = 13;
   */
  storableProfileSeedEncPubKeySignature: Uint8Array;

  /**
   * @generated from field: repeated domain.ProfileAuthenticatorLock authenticator_locks = 14;
   */
  authenticatorLocks: ProfileAuthenticatorLock[];

  /**
   * NOTE: Contains locks from upstream profiles that lock this profile. Currently, that is
   * specifically locks from user profiles that lock admin profiles.
   *
   * @generated from field: repeated domain.ProfileProfileLock upstream_profile_locks = 16;
   */
  upstreamProfileLocks: ProfileProfileLock[];
};

/**
 * Describes the message domain.ProfileData.
 * Use `create(ProfileDataSchema)` to create a new message.
 */
export const ProfileDataSchema: GenMessage<ProfileData> = /*@__PURE__*/
  messageDesc(file_profile, 0);

/**
 * @generated from message domain.ForeignProfile
 */
export type ForeignProfile = Message<"domain.ForeignProfile"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string key_generation_id = 2;
   */
  keyGenerationId: string;

  /**
   * @generated from field: domain.ProfileType profile_type = 3;
   */
  profileType: ProfileType;

  /**
   * @generated from field: string organization_id = 4;
   */
  organizationId: string;

  /**
   * @generated from field: bytes high_security_identity_sig_pub_key = 5;
   */
  highSecurityIdentitySigPubKey: Uint8Array;

  /**
   * @generated from field: bytes high_security_vault_key_enc_pub_key = 6;
   */
  highSecurityVaultKeyEncPubKey: Uint8Array;

  /**
   * @generated from field: bytes high_security_vault_key_enc_pub_key_signature = 7;
   */
  highSecurityVaultKeyEncPubKeySignature: Uint8Array;

  /**
   * @generated from field: bytes high_security_profile_seed_enc_pub_key = 8;
   */
  highSecurityProfileSeedEncPubKey: Uint8Array;

  /**
   * @generated from field: bytes high_security_profile_seed_enc_pub_key_signature = 9;
   */
  highSecurityProfileSeedEncPubKeySignature: Uint8Array;

  /**
   * @generated from field: bytes storable_sig_pub_key = 10;
   */
  storableSigPubKey: Uint8Array;

  /**
   * @generated from field: bytes storable_sig_pub_key_signature = 11;
   */
  storableSigPubKeySignature: Uint8Array;

  /**
   * @generated from field: bytes storable_vault_key_enc_pub_key = 12;
   */
  storableVaultKeyEncPubKey: Uint8Array;

  /**
   * @generated from field: bytes storable_vault_key_enc_pub_key_signature = 13;
   */
  storableVaultKeyEncPubKeySignature: Uint8Array;

  /**
   * @generated from field: bytes storable_profile_seed_enc_pub_key = 14;
   */
  storableProfileSeedEncPubKey: Uint8Array;

  /**
   * @generated from field: bytes storable_profile_seed_enc_pub_key_signature = 15;
   */
  storableProfileSeedEncPubKeySignature: Uint8Array;

  /**
   * @generated from field: string email = 16;
   */
  email: string;
};

/**
 * Describes the message domain.ForeignProfile.
 * Use `create(ForeignProfileSchema)` to create a new message.
 */
export const ForeignProfileSchema: GenMessage<ForeignProfile> = /*@__PURE__*/
  messageDesc(file_profile, 1);

/**
 * @generated from message domain.ProfileRegenerateData
 */
export type ProfileRegenerateData = Message<"domain.ProfileRegenerateData"> & {
  /**
   * @generated from field: domain.ProfileData profile = 1;
   */
  profile?: ProfileData | undefined;

  /**
   * @generated from field: repeated domain.VaultLockCreationData vault_locks = 2;
   */
  vaultLocks: VaultLockCreationData[];

  /**
   * NOTE: Contains locks to downstream profiles that are locked by this profile. Currently, that is
   * specifically locks from user profiles that lock admin profiles
   * and locks from admin profiles to child organization admin profiles
   *
   * @generated from field: repeated domain.ProfileProfileLock downstream_profile_locks = 3;
   */
  downstreamProfileLocks: ProfileProfileLock[];
};

/**
 * Describes the message domain.ProfileRegenerateData.
 * Use `create(ProfileRegenerateDataSchema)` to create a new message.
 */
export const ProfileRegenerateDataSchema: GenMessage<ProfileRegenerateData> = /*@__PURE__*/
  messageDesc(file_profile, 2);

